import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";
import {
  obtenerRepresentanteLegal,
  representanteLegalPorInstitucion,
} from "../../Services/Rest";
import Cookies from "universal-cookie";

import CreaRepresentanteLegal from "./CreaRepresentanteLegal";
import EditarRepresentante from "./EditarRepresentante";
import img from "../Loader//spinner.gif";

function RepresentanteLegal(props) {
  const urlA = obtenerRepresentanteLegal;
  const urlU = representanteLegalPorInstitucion;
  const cookie = new Cookies();

  if (cookie.get("tipo_Usuario") == 1) {
    var urlendpoint = urlU + props.idInstitucion;
  }
  if (cookie.get("tipo_Usuario") == 2) {
    var urlendpoint = urlU + cookie.get("institucionid");
  }
  if (cookie.get("tipo_Usuario") == 3) {
    var urlendpoint = urlU + props.idInstitucion;
  }
  if (cookie.get("tipo_Usuario") == 4) var urlendpoint = urlA;
  const [isLoading, setLoading] = useState(false);
  const cookies = new Cookies();
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: urlendpoint,
    })
      .then((Response) => {
        setList(Response.data);
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
        }, 2000);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  const [postEstado, setPostEstado] = useState([]);
  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/ObtenerInstituciones",
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);
  const BusacarPorEstado = () => {
    axios
      .get(representanteLegalPorInstitucion + postEstado)
      .then((response) => {
        setList(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handlecountry = (event) => {
    const EStadoId = event.target.value;
    setPostEstado(EStadoId);
  };
  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Información Representante Legal
                </h6>
              </div>
              <div class="card-body">
                {cookie.get("tipo_Usuario") == 1 ? (
                  <form>
                    <select
                      className="btn btn-secondary btn-user btn-block text-left"
                      onChange={(e) => handlecountry(e)}
                    >
                      <option value="0">Seleccione </option>

                      {list1.map((getcon, index) => (
                        <option key={index} value={getcon.id}>
                          {getcon.razon_Social}{" "}
                        </option>
                      ))}
                    </select>

                    <button
                      className="btn btn-primary btn-user btn-block"
                      onClick={() => BusacarPorEstado()}
                    >
                      buscar
                    </button>
                    <hr />
                  </form>
                ) : (
                  <h1></h1>
                )}
                {cookies.get("tipo_Usuario") == 2 ? (
                  <CreaRepresentanteLegal />
                ) : (
                  <h1></h1>
                )}
                <br></br>
                <div class="table-responsive">
                  <center>
                    {isLoading ? (
                      ""
                    ) : (
                      <a>
                        <table
                          class="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Nombre</th>
                              <th>Tipo Documento</th>
                              <th>Documento</th>
                              <th>Telefono Contacto</th>
                              <th>Ciudad</th>
                              <th>Direccion</th>
                              <th>Correo Electronico</th>
                              <th>Institucion</th>
                              {cookie.get("tipo_Usuario") == 2 ? (
                                <th>Acción</th>
                              ) : (
                                <h1></h1>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {list.map((item) => {
                              return (
                                <tr>
                                  <td>{item.nombre}</td>
                                  <td>{item.tipo_Documento}</td>
                                  <td>{item.documento}</td>
                                  <td>{item.teleFonoContacto}</td>
                                  <td>{item.ciudad}</td>
                                  <td>{item.direccion}</td>
                                  <td>{item.correo}</td>
                                  <td>{item.institucion}</td>
                                  {cookie.get("tipo_Usuario") == 2 ? (
                                    <td>
                                      <EditarRepresentante
                                        idRepresentante={item.id}
                                        nombre={item.nombre}
                                        correo={item.correo}
                                        direccion={item.direccion}
                                        ciudad={item.ciudad}
                                        telefono_Contacto={
                                          item.teleFonoContacto
                                        }
                                        documento={item.documento}
                                      />
                                    </td>
                                  ) : (
                                    <h1></h1>
                                  )}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </a>
                    )}
                  </center>
                  {isLoading ? (
                    <div>
                      <img
                        style={{ width: "200px", height: "200px" }}
                        src={img}
                      />{" "}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default RepresentanteLegal;
